/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The port number of the target.
 * @export
 * @interface TargetPort
 */
export interface TargetPort {
  /**
   *
   * @type {number}
   * @memberof TargetPort
   */
  number?: number;
  /**
   * TLS configuration for the target.
   * @type {string}
   * @memberof TargetPort
   */
  tls?: string;
}

/**
 * Check if a given object implements the TargetPort interface.
 */
// @ts-ignore
export function instanceOfTargetPort(value: object): value is TargetPort {
  return true;
}

export function TargetPortFromJSON(json: any): TargetPort {
  return TargetPortFromJSONTyped(json, false);
}

export function TargetPortFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): TargetPort {
  if (json == null) {
    return json;
  }
  return {
    number: json['number'] == null ? undefined : json['number'],
    tls: json['tls'] == null ? undefined : json['tls'],
  };
}

export function TargetPortToJSON(json: any): TargetPort {
  return TargetPortToJSONTyped(json, false);
}

export function TargetPortToJSONTyped(
  value?: TargetPort | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    number: value['number'],
    tls: value['tls'],
  };
}
